import React from 'react'
import PropTypes from 'prop-types'

import MainLayout from '../../layouts/Main'

const PreduvedumlenieView = () => {
    return (
        <MainLayout>
            <div className="row justify-content-center">
                <main className="col-md-12 col-lg-10">
                    <div className="jumbotron">
                        <h1 className="display-4">ХОРАТА РАЗКАЗИ</h1>
                        <p className="lead">ЗАВРЪЗКАТА</p>
                    </div>
                    <p>
                        Големият разказ за хората разкази от „Паисиада" се завързва така:
                    </p>
                    <p>
                        Годината е 1762.
                    </p>
                    <p>
                        Мястото на действието – Зографският манастир на Света гора Атонска.
                    </p>
                    <p>
                        Събитието – йеромонах Паисий Хилендарски слага заключителната точка на Зографската чернова – една ръкописна
                        първоистория, която може да се определи като обрамчена история, а нейният съставител – като първия герой от хората
                        разкази в условното „Царство Паисиада".
                    </p>
                    <p>
                        Ако се абстрахираме от детайлите на „История славянобългарска" и пожелаем да я представим с изреченията, които
                        съдържат най-градивното послание на първия от хората разкази в „Паисиада", то тези въобразени от мен изречения ще
                        прозвучат по начина:
                    </p>
                    <p>
                        „В обрамчената първоистория „История славянобългарска" йеромонах Паисий проигумен Хилендарски прорицава: че не е
                        недостойно да си българин; че не е недостойно да милееш за Своя Род и Своето Отечество; че не е недостойно да
                        проповядваш Своята Вяра и да говориш на Своя език! НО Е ДЪЛБОКО НЕДОСТОЙНО ДА СИ ЮРОДИВ БЪЛГАРИН!"
                    </p>
                    <p>
                        Ръкописвана с паче перо, потопено в мастило от сажди, „История славянобългарска" се превръща в книга – национална
                        Институция. И се сдобива с благослучна съдба – с такава съдба, каквато никоя друга ръкописна възрожденска книга не
                        постига в своя път към нас. Родено на Света гора Атонска, прорицанието от обрамчената Паисиева история става онова
                        духовно събитие, което провокира хората разкази – преписвачите на „Паисиада" – да я преписват и преправят, за да
                        популяризират стотици години след съставянето ѝ въжделенията на Отец Паисий.
                    </p>
                    <p>
                        През годините, в които изучавам и преподавам в университета литературата и културата на Българското възраждане, все
                        се питам кое е онова Нещо, което кара възрожденските ни предци да ръкописват „История славянобългарска" в
                        продължение на 117 години. И да го правят без прекъсване, дори и тогава, когато Паисиевата ръкописна книга вече е
                        била публикувана с името „Царственик…". И да го правят без прекъсване, дори и тогава, когато вече са могли да си
                        закупят „Царственика…", за да го имат за собствена потреба и у дома. И кое е онова Нещо, което кара възрожденските
                        ни предшественици да преписват и преправят „История славянобългарска" отново на ръка, като ползват за извод дори и
                        печатния „Царственик…", който е преписван на ръка от преписвачите на четири павликянски преписа на Паисиевата
                        история (Ръкопис № НБКМ 777, Ръкопис № НБКМ 1312, Ръкопис № НБКМ 1313, Ръкопис № НБКМ 1314), също и от поп Костадин
                        Чучулайн, съставител на последния от известните на науката преписи от „Паисиада" (Чучулайн препис, 1882, Банско).
                    </p>
                    <p>
                        Няма лесен и еднозначен отговор на поставените въпроси. Но ако отговорите се подирят в контекста на вече
                        разгърнатите теоретични концепции, то тогава те биха могли да прозвучат така:
                    </p>
                    <p>
                        1. Мислена в (над)националния, социалнополитически и историкокултурен контекст, „История славянобългарска" има за
                        основен конструктивен принцип легитимацията на модерното знанието за България, българите и българското. Това
                        знание, което тя проповядва и сред Своите, и сред Другите, се отстоява с правилните предписателни и оценъчни изкази
                        от типа:
                    </p>
                    <p>

                        <em>„Четете и знайте, за да не бивате осмивани и укорявани от други племена и народи." </em>(ИС 2012: 56; 57).
                    </p>
                    <p>

                        <em>„Преписвайте тази историйца и платете, нека ви я препишат, които умеят да пишат, и пазете я да се не погуби!"
                        </em>(ИС 2012: 58; 59).
                    </p>
                    <p>

                        <em>„О, неразумне и юроде, поради що се срамиш да се наречеш болгарин и не четеш, и не говориш на своя език." </em>(ИС
                        2012: 58; 59).
                    </p>
                    <p>
                        2. Поради многобройните преписи и преправки, направени и у нас, и в чужбина, т.е. благодарение на „медийна мрежа
                        Паисиада", книгата национална институция „История славянобългарска" се сдобива с уникалното право да съумява да
                        подсигури публичността, достъпността, прозрачността на модерния си легитимационен проект:
                    </p>
                    <ul>

                        <li>който се (пре)предава по метода „от уста на ухо" сред безкнижните „прости орачи и копачи, овчари и прости
                            занаятчии" (ИС 2012: 63);</li>
                        <li>който се чете и самостойно от любородните представители на възрожденската интелигенция и от чуждите учени;</li>
                        <li>който се преписва и преправя и от български възрожденци от разни възрасти и професии, и от чужденци (по
                            различно време и на различни места).</li>
                    </ul>

                    <p>
                        И всичко това се постига, за да се умножават посланията на „История славянобългарска" сред (не)любомъдрите
                        съвременници на монаха историописец във и отвъд Отечеството. Така възрожденската ръкописна книга национална
                        институция „История славянобългарска" се сдобива по право с легитимиращата мощ да бъде ядро на Големия разказ за
                        хората разкази от „Паисиада". И с право се превръща във Велик код, с който се легитимират критериите за
                        компетентност при отграничаването на интимното Свое, от профанното Несвое.
                    </p>
                    <p>
                        3. Повествованието на Паисий се сдобива и с легитимиращата сила да съумее да завърже сюжетния възел на макросюжета
                        на Големя разказ, защото учредява, определя, остойностява, валидизира критериите за компетентност в национално
                        консилидационния Канон за (не)допустимите връзки между Аз и Ние, от една страна, и Ние и Те, от друга. А Канонът на
                        българското възрожденско робско време, разломено от Хаоса в Игото, повелява: щом Отечеството ни отколе е във
                        властта на „чедата Агарини и Измаилеви" (ИС 2012: 25 5), а и дълго още е щяло да влачи хомота на чуждото бреме, то
                        Ние – поробеното племе, много повече, отколкото Те – обитателите на модерната тогавашна Европа, сме имали потребата
                        да вярваме в причастяващата мощ на Големите си разкази. Вървейки подир Канона, учреден от Паисиевото първоизворно
                        слово, открехнало дверите на „Царството Паисиада", съвремието на монаха все ще отстоява, че Аз-ът на поробения,
                        който е нещастен и юродив, няма силата да решава, да оценява, да преобразува, да познава егоцентрично. Което пък
                        значи, че Азовата съдбовноств условията на политическа и религиозна несвободане се счита за легитимна; което пък
                        значи, че Азът може да придобие значимост, но само ако е конструктивна част на общностното българско възрожденско
                        Ние. Защото отвъд Ние няма нищо друго, освен Те! Така връзките Аз-и-Ние, според учреденото в ръкописната
                        възрожденска книгата национална институция „История славянобългарска", не могат да бъдат различаващи и не бива да
                        бъдат противопоставящи се. (Интересни са наблюденията на М. Грекова за социополитическия дискурс на Аз и Другия в
                        съвременните посттоталитарни общества. Тези наблюдения в някаква степен спомогнаха за концептуализацията и на моите
                        представи, вж. Грекова 1996).
                    </p>
                    <p>
                        В Големия разказ, захванат от Отец Паисий, ги има и Големите герои – престижните Отци на българското племе. Те са
                        водачите в политическата държавност (царете); те са пастирите на вярата (патриарсите, архиереите, светомъчениците);
                        те са апостолите в културата (будителите). В отколешните български царства, доверява ни Отец Паисий (и в Първото –
                        просъществувало между 681 и 1018 г.; и във Второто – господарувало между 1185 и 1396 г.), е имало и независима
                        българска държава, имало е и верска самостойност. Все тогава е властвало и бащиното право, белязано от силата на
                        бащината обич, дарявана на Своите синове, почели Завета на племето. Все тогава е господарувала и бащината омраза,
                        оплодена от куража на Отците, който ги е карал без страх да наказват юродивите Свои чеда, които уж са бивали Свои,
                        но в психичната им кройка е доминирала различността, белязана от култа към кривосхващаната другост. (Бащиното
                        право, бащината обич, бащината омраза са психични институции, чийто теоретичен пълнеж се представя от Bachofen
                        1861: 129 – 178).
                    </p>
                    <p>
                        В Големия разказ, който Паисий пръв подхваща, я има и Голяма опасност:
                    </p>
                    <ul>

                        <li>тя е онази, която приижда отвън, внесена е от Чужденците;</li>
                        <li>тя е и онази, с която Другите беснеят над бащиното огнище (метафориката е по Ботев);</li>
                        <li>тя е и онази, която посипва родословните нишки с пепелта на Забравата;</li>
                        <li>тя е и онази, която коси земята на Отец-Паисиевата България със „скръб върху скръб и жалост върху жалост" (ИС
                            2012: 255);</li>
                        <li>тя е и онази, която затрива хубави българки и посича непрежалими мъжки чеда, и бастисва Апостоли, и погазва и
                            Дом, и Храм, и Род, и Отечество...</li>
                    </ul>

                    <p>
                        Но тя е и тази, която покълва и отвътре, в самия корен на българския (на)род, защото юродивото българско отхранва и
                        синове отцеругатели, озлочестили с недостойното си билó свещеното бащино име и племе.
                    </p>
                    <p>
                        В Големия разказ „Царството „Паисиада" и хората разкази", завързан най-първом в ръкописната книга национална
                        институция „История славянобългарска", го има и Голямото пътешествие. Такова е пътешествието назад, към и в
                        Историята на старите български царства и тяхната Свобода. Такова е и пътешествието навън към Букурещ, Кирсово,
                        Болград, Одеса, Москва, Санкт-Петербург… – все места на памет за престижното българско, за което са разказвали
                        занесените там възрожденски преписи и преправки от „Паисиада".
                    </p>
                    <p>
                        Ръкописната книга национална институция „История славянобългарска", е осветена и от Голямата цел. Разказвайки
                        главно за преминалото добруване на „великите владетели" (ИС 2012: 51), а сетне и за техните синове, а и за техните
                        наследници – Паисий пръв, със сетивата си и за идното българско, конструира опорите на Големия разказ за хората
                        разкази в „Паисиада". И го разправя такъв, какъвто хората разкази нататък са могли да го:
                    </p>
                    <ul>

                        <li>преписват</li>
                        <li>преправят</li>
                        <li>дописват</li>
                        <li>превеждат</li>
                        <li>пресъставят</li>
                        <li>четат на глас</li>
                        <li>разпространяват…</li>
                    </ul>

                    <p>
                        За да го предават и нататък! Един метанаратив на Българското възраждане – натежал от метафорични видения, опастрили
                        памет за високото, трайното, престижното Свое, което пулсира и в моята кръв, и в кръвта на читателите на тази
                        книга. Един метанаратив на Българското възраждане – дарил на поломените в робството наши предшественици мъдростта
                        на Голямата вяра, че българското ще пребъде. Разгласен от един монах, забравил болката на тленното тяло, защото
                        неистово бе възлюбил Своето Отечество, Големият разказ за хората разкази в „Паисиада" пося семето на благата вест,
                        че е по силите на нещастните поробени български фамилии да преоткрият чудотворните мощи на бащината вяра и да
                        пренапишат изконното Свое със знаците и символите, сътворени „in illo tempore, ab origine" (културната метафора in
                        illo tempore, ab origine e на Мирча Елиаде).
                    </p>
                    <p>
                        4. У Паисий я има и философията на Историята. Терминът философия на историята тук се възприема в посоката, описана
                        от Р. Колингууд, а именно – като знание за обекта, постигнато по пътя на философската рефлексия, в която
                        субективните представи на историка, изказани по повод мисленето за и в Историята, са от съществено значение
                        (Колингууд 1995: 5 – 6). Тази философия на историята узаконява казуса: щом българският корен е заченат от Ной
                        (първоотецът на оцелялото Човечество), то значи, че Бог ни обича дълбоко! И истински! И бащински! И ни обича точно
                        такива, каквито сме били отколе в царското българско време. Но ни обича и такива, каквито сме и сега, в „лютото
                        време" (ИС 2012: 65), в което живее Отец Паисий. Благата вест на историописец, научил уроците на Историята, които
                        порицават , че щом Бог ни е избрал, то значи ни е и орисал да преминем и през този въртоп! А е знайно, настоява
                        Паисий Хилендарски, че след Потопа следва Възкресението!
                    </p>
                    <p>
                        Модерното знание, чиито основи Паисий положи във видимото и невидимото на възрожденската ръкописна книга национална
                        институция „История славянобългарска", в нейното време, достигна до всяко кътче на българска земя, а „медийната
                        мрежа Паисиада" го разгласи не само „от Охрид до Тулча и от Белград до Цариград" (Димитров 2008), но и извън
                        етническите граници на България: в Русия, в Румъния, в Сърбия, в Света гора, в Бесарабия – навсякъде, където
                        пътешестват ръкописите от Паисиада през деветнадесети век.
                    </p>
                    <p style={{textAlign: 'right'}}> © Автор: доц. д-р Мила Кръстева</p>

                </main>
            </div>
        </MainLayout>
    )
}

PreduvedumlenieView.propTypes = {

}

export default PreduvedumlenieView



// WEBPACK FOOTER //
// ./src/views/Zavrazkata/index.jsx